var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBadgeStar = function SvgBadgeStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.378 0H.5v30.792c0 .868 1.212 1.301 1.922.688l8.28-4.71c.44-.38 1.156-.38 1.596 0l8.28 4.71c.71.613 1.922.18 1.922-.688V0h-1.127.005z",
    fill: "#E4E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.56 15.383l1.892-1.844a.528.528 0 00-.292-.9l-2.614-.381a.532.532 0 01-.398-.288l-1.171-2.372a.526.526 0 00-.945 0L9.861 11.97a.532.532 0 01-.397.288l-2.615.38a.528.528 0 00-.292.9l1.893 1.845a.537.537 0 01.15.466l-.446 2.607a.529.529 0 00.767.555l2.338-1.228a.525.525 0 01.49 0l2.34 1.228c.389.203.839-.126.766-.555l-.446-2.607a.514.514 0 01.15-.466z",
    fill: "#fff"
  })));
};
export default SvgBadgeStar;